import { SearchFormData, getListingInputOrderFromRegionCode, getRegion } from '@steelbuy/ts-shared';
import { DashboardFormData } from '../dashboard-listings.tsx/DashboardFormContext';

type ValueOf<T> = T[keyof T];

const removeUndefined = <T extends Record<string, unknown>>(obj: T): Partial<T> =>
    Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined)) as Partial<T>;

export const mapSearchToBrowseListingForm = (searchFormData: SearchFormData): DashboardFormData => {
    const listingInputs = getListingInputOrderFromRegionCode(getRegion().regionCode) as Array<keyof SearchFormData>;

    const additionalFields = listingInputs.reduce((acc, input) => {
        if (searchFormData?.[input]) {
            acc[input] = [searchFormData[input]];
        }
        return acc;
    }, {} as Record<keyof SearchFormData, ValueOf<DashboardFormData>>);

    const dimensions = removeUndefined({
        width: searchFormData.width,
        length: searchFormData.length,
    });

    const dimensionRanges = removeUndefined({
        maxWidth: searchFormData.maxWidth,
        minWidth: searchFormData.minWidth,
        maxLength: searchFormData.maxLength,
        minLength: searchFormData.minLength,
    });

    return {
        ...removeUndefined({
            product: searchFormData.product && [searchFormData.product],
            shape: searchFormData.shape && [searchFormData.shape],
            materialType: searchFormData.materialType,
            gauge: searchFormData.gauge && [searchFormData.gauge],
            thickness: searchFormData.thickness,
            definition: searchFormData.definition,
            thicknessType: searchFormData.thicknessType && [searchFormData.thicknessType],
        }),
        ...(Object.keys(dimensions).length && { dimensions }),
        ...(Object.keys(dimensionRanges).length && { dimensionRanges }),
        ...additionalFields,
    } as DashboardFormData;
};
